import { EditConfigButton } from "./editConfigButton/editConfigButton";
import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";

const formatReportLink = ({ value }) => value || "—";

export const getColumns = (clients, onConfigUpdated) => [
  DefaultColumnOptions.Id,
  {
    field: "clientName",
    headerName: "Client",
    sort: "asc",
  },
  {
    field: "recruiterProductivityReportLink",
    headerName: "Recruiter Productivity Report Source",
    headerTooltip: "Recruiter Productivity Report Source",
    tooltipField: "recruiterProductivityReportLink",
    valueFormatter: formatReportLink,
  },
  {
    field: "weeklyReportLink",
    headerName: "Weekly Report Source",
    headerTooltip: "Weekly Report Source",
    tooltipField: "weeklyReportLink",
    valueFormatter: formatReportLink,
  },
  {
    field: "monthlyReportLink",
    headerName: "Monthly Report Source",
    headerTooltip: "Monthly Report Source",
    tooltipField: "monthlyReportLink",
    valueFormatter: formatReportLink,
  },
  {
    field: "dashboardReportLink",
    headerName: "Dashboard Report Source",
    headerTooltip: "Dashboard Report Source",
    tooltipField: "dashboardReportLink",
    valueFormatter: formatReportLink,
  },
  {
    ...DefaultColumnOptions.Actions,
    cellRenderer: (params) => {
      return (
        <EditConfigButton
          configuration={params.data}
          clients={clients}
          onSuccess={onConfigUpdated}
        />
      );
    },
  },
];
